import PreparatoryStandardsPage from './_PreparatoryStandardsPage'

export default function ComberSettingsPage() {
  return <PreparatoryStandardsPage kind="comber" />
}
